import React , {useState , useEffect ,useRef} from 'react'
import { Table, Input,DatePicker,Tag,Button,Card , Pagination,Radio,InputNumber} from 'antd';
import {
  addFilteredValue,
  addFilteredPlanValue
} from "../../store/slice/couponslistFilter-slice";
import { useSelector, useDispatch } from "react-redux";
import { SearchOutlined} from "@ant-design/icons";
import Loader from "Components/Loader";
import {message,Form,Select,Modal} from "antd";
import { Edit } from 'Common/ReactIcons';
import { CONSTANTS } from "utils/constant";
import "../CareAdmin/CareAdmin.scss";
import dayjs from "dayjs";
import api from "utils/api";
import utils from "utils";
import Validators from "Common/Validators";
const { RangePicker } = DatePicker;

const usageOptions=[{
  label:"Single",
  value:"0"
},{
  label:"Multiple",
  value:"1"

}]
const ManageCoupon = () =>{
  const createCouponForm = useRef(null);
  const [data, setdata] = useState( []);
  const filtered_value = useSelector((state) => state.couponListFilterReducer.filteredValue);
  const filtered_plan_value = useSelector((state) => state.couponListFilterReducer.filteredPlanValue);
  const user_details= useSelector((state)=>state.loginReducer.user_details)
  const [selectedKeys, setSelectedKeys] = useState(filtered_value||"");
  const [selectedPlan, setSelectedPlan]= useState(filtered_plan_value||"");
  const [count,setCount] = useState(0);
  const [pageNo,setPageNo] = useState(1);
  const [pageSize,setPageSize] = useState(20);
  const [search,setSearch] = useState(false)
  const [isinnerLoading,setisinnerLoading] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [create_coupon, setCreateCoupon] = useState(false);
  const [isCouponSearch, setIsCouponSearch] = useState(false);
  const [isPlanSearch, setIsPlanSearch]= useState(false);
  const [couponReset,SetCouponReset] = useState(false);
  const [planReset, SetPlanReset] = useState(false);
  const [usageMode , setUsageMode] = useState("0")

  const dispatch = useDispatch();
 
  let setExpiryDate=""
  const handleReset = (col) => {
 
    if(col=="plan_name"){
      setSelectedPlan(""),
      dispatch(addFilteredPlanValue(""))
      getData(1,20,"",selectedKeys)
      SetPlanReset(false)
    }else{
    setSelectedKeys(""),
    dispatch(addFilteredValue(""))
    getData(1,20,selectedPlan,"")
    SetCouponReset(false)
    }
    setisinnerLoading(true)
    
  };

  const handlePlanSearch = (data)=>{
    setisinnerLoading(true)
    if(data?.length>0)
    {getData(1,20,data,filtered_value)
        dispatch(addFilteredPlanValue(data))
    }else{
    handleReset("plan_name")
    }
    setIsPlanSearch(false)
  }

  const handleCouponSearch=(data)=>{
    setisinnerLoading(true)
    if(data?.length>0)
    {getData(1,20,filtered_plan_value,data)
        dispatch(addFilteredValue(data))
    }else{
    handleReset("coupon_name")
    }
    setIsCouponSearch(false)
  }
  const columns = [
    {
      title: `${CONSTANTS.PLAN_NAME}`,
      dataIndex: 'service_name',
      key: 'service_name',
      filterDropdown: ({
        confirm,
        clearFilters,
        close
      }) => {
        return (
          <Card style={{position:"absolute",width:"250px",padding:"5px"}}>
  
            <Input
              autoFocus
              placeholder="Type text here"
              defaultValue={""}
            value={isPlanSearch?selectedPlan:filtered_plan_value}
            onBlur={()=>setIsPlanSearch(false)}
              allowClear={false}
              onChange={(e) => {              
            setSelectedPlan(e.target.value)
            setIsPlanSearch(true)
            e.target.value?.trim()?.length>0?SetPlanReset(true):SetPlanReset(false)
               }}
             
             
            ></Input>
            
            <Button
            type='primary'
            style={{float:"left",marginTop:"5px"}}
            onClick={()=> {
              // setSelectedPlan(selectedPlan?.trim())
              handlePlanSearch(selectedPlan?.trim())
                  close()}}
            >
            {CONSTANTS.SEARCH}
            </Button>
  
            <Button
              className='reset-btn'
              onClick={() => {handleReset("plan_name"),clearFilters(),confirm()}}
              style={{color:"#7A271A",boxShadow:"none",float:"right",marginTop:"5px"}}
              disabled={!planReset}

            >
              {CONSTANTS.RESET}
            </Button>
           
          </Card>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.service_name.toLowerCase().includes(value.toLowerCase());
      },
      
      render: (data) => (
        data)
  },
    {
      title: `${CONSTANTS.COUPON_NAME}`,
      dataIndex: 'coupon_name',
      key: 'coupon_name',
      filterDropdown: ({
        confirm,
        clearFilters,
        close
      }) => {
        return (
          <Card style={{position:"absolute",width:"250px",padding:"5px"}}>

            <Input
              autoFocus
              placeholder="Type text here"
            
              defaultValue={""}
              value={isCouponSearch?selectedKeys:filtered_value}
              allowClear={false}
              onBlur={()=>setIsCouponSearch(false)}
              onChange={(e) => {
              setSelectedKeys(e.target.value)
              setIsCouponSearch(true)
              e.target.value?.trim()?.length>0?SetCouponReset(true):SetCouponReset(false)
               }}
             
             
            ></Input>
            
            <Button
            type='primary'
            style={{float:"left",marginTop:"5px"}}
            onClick={()=> {
              handleCouponSearch(selectedKeys?.trim())
                  close()}}
            >
              {CONSTANTS.SEARCH}
            </Button>

            <Button
              className='reset-btn'
              onClick={() => {handleReset("coupon_name"),clearFilters(),confirm()}}
              style={{color:"#7A271A",boxShadow:"none",float:"right",marginTop:"5px"}}
              disabled={!couponReset}
            >

              {CONSTANTS.RESET}
            </Button>
           
          </Card>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.coupon_name.toLowerCase().includes(value.toLowerCase());
      },
      
      render: (data) => (
        data)
  },

   
    {
      title: `${CONSTANTS.COUPON_CODE_1}`,
      dataIndex: 'coupon_code',
      key: 'coupon_code',
      render: (data) => (data)
  },
    {
        title: `${CONSTANTS.DESCRIPTION}`,
        dataIndex: 'description',
        key: 'description',
         render: (data) => (data)
    },
    {
        title: `${  CONSTANTS.DISCOUNT_PERCENT}`,
        dataIndex: 'discount_percentage',
        key: 'discount_percentage',
        align:"center",
        render: (data) => (data + "%")
    },
    {
      title: `${CONSTANTS.START_DATE}`,
      align:"center",
      dataIndex: 'start_date_time',
      key: 'start_date_time',
      
       render: (data) => <div style={{display:"grid",textAlign:"center"}}><span>{utils.FormatDate(data, "DATE_14")}</span>
      </div>
  },
    {
        title: `${CONSTANTS.EXPIRY_DATE}`,
        align:"center",
        dataIndex: 'expiry_date_time',
        key: 'expiry_date_time',
        
         render: (data) => <div style={{display:"grid",textAlign:"center"}}><span>{utils.FormatDate(data, "DATE_14")}</span>
        </div>
    },
    {
      title: `${CONSTANTS.COUPON_USAGE}`,
      dataIndex: 'is_single_use',
      key: 'is_single_use',
      align:'center',
      render: (data,i) => <div  style={{textAlign:"center"}} onClick={editDate.bind(data,i)}>

        {data==true?
        <Tag color="yellow">Single</Tag>:
        <Tag color='green'>Multiple</Tag>
    }
          </div>
  },
    {
        title: `${CONSTANTS.EDIT}`,
        dataIndex: 'edit',
        key: 'edit',
        align:'center',
        render: (data,i) => <div  style={{textAlign:"center"}} onClick={editDate.bind(data,i)}>
           <Button style={{border:"none",boxShadow:"none",background:"none"}}><Edit /></Button>
            </div>
    }
  ];
  const handleSearch=(selectedKeys)=>{
  
    if(selectedKeys.trim().length>0)
                {getData(1,20,selectedKeys.trim()),
                    dispatch(addFilteredValue(selectedKeys.trim()))
                    setSearch(false)
                    
                }else{
                  getData(1,20,"")
                  dispatch(addFilteredValue(""))
                }
                setSearch(false)
  }
  const handlePagination = (pageNo,pageSize)=> {
    setisinnerLoading(true)
    pageNo= pageNo||1
    setPageNo(pageNo) 
    setPageSize(pageSize) 
    getData(pageNo,pageSize,filtered_plan_value,filtered_value)
  }
  const getData = async (pageNo,pageSize,selectedPlan,selectedKeys) => {
    const service_response = await api.get_list_service()
    if(service_response.status == 200){
      setServiceList(service_response.data.data.results)
    }
    const res = await api.get_coupon_list(pageNo,pageSize,selectedPlan,selectedKeys);
    
    if(res.data.status ==200){
        let {data} = res.data ;
        setCount(data.count)  
        setPageNo(pageNo) 
        setPageSize(pageSize) 
        setdata(res.data.data.results),
        setisinnerLoading(false)
        if(selectedKeys?.length>0){
          SetCouponReset(true)
        }
        if(selectedPlan?.length>0){
          SetPlanReset(true)
        }
        
    }else{
        message.error(res.data?.message, ErrorDuration);
    }
    setisinnerLoading(false)
  };
  const editDate=(data,i)=>{
    utils.Modal(true, {
        width: "650px",
        content:
        <div className="coupon-Consult-Modal">
        <div className="finish-header">{CONSTANTS.UPDATE_EXP_DATE}</div>
        <div className="finish-wrapper">
            <div className="finish-title">
            <div className='coupon-details' >
                     <b>{CONSTANTS.PLAN_NAME}</b>
                     <span>&nbsp; :</span>
                   <p>  {data.service_name}</p>
                   </div>
                    <div className='coupon-details' >
                     <b>{CONSTANTS.COUPON_NAME} </b>
                  <span>&nbsp; :</span>
                   <p>  {data.coupon_name}</p>
                   </div>   
                   <div className='coupon-details' >
                     <b>{CONSTANTS.COUPON_CODE_1} </b>
                     <span>&nbsp; :</span>
                   <p>  {data.coupon_code}</p>
                   </div>
                    <div className='coupon-details' >
                   <b>{CONSTANTS.DESCRIPTION}</b>
                   <span>&nbsp; :</span>
                      <Input.TextArea style={{width:"70%",marginBottom:"10px"}} disabled={true} value={data.description}>{data.description}</Input.TextArea>
                    </div>
               <div className='coupon-details' >
               <b>{CONSTANTS.EXPIRY_DATE}</b>
               <span>&nbsp; :</span>
                     <RangePicker                      
                     className="follow-up-datepicker"
                     disabled={[true, false]}
                     superPrevIcon={null}
                     superNextIcon={null}
                     format="DD/MM/YYYY"
                     showToday={false}
                     defaultValue={[dayjs(data.start_date_time),dayjs(data?.expiry_date_time)]}
                     onChange={(e)=>{setExpiryDate=dayjs(e?.[1])}}
                     disabledDate={(current) =>{
                      return current.isBefore(utils.FormatDate(data.start_date_time, "UTC") )
                  }}
                     allowClear={false}/>
                     </div> 
                     <div className='coupon-details' >
                     <b>{CONSTANTS.COUPON_USAGE} </b>
                     <span>&nbsp; :</span>
                   <Radio.Group 
                       options={usageOptions}
                       defaultValue={data?.is_single_use == true?"0":"1"}  
                       onChange={(e)=>setUsageMode(e.target.value)}
                       />
                   </div>
                   
            </div>
            <div className="finish-btns submit-btn-wrapper">
                <Button className="action-yes" onClick={(e)=>{saveExpiryDate(data)}} >{CONSTANTS.SAVE}</Button>
            </div>
        </div>
    </div>
      })

  }
  const createCouponModal=(data,i)=>{
    utils.Modal(true,{
      width:"650px",
     
      content:
      <div  className="coupon-Consult-Modal" >
         <div className="finish-header">{CONSTANTS.CREATE_COUPOUN}</div>
         <div className="finish-wrapper">
                       <Form 
                             name="add-coupon"
                             ref={createCouponForm}
                             onFinish={(val)=>createCoupon(val)}
                             labelCol={{
                               span: 8,
                             }}
                             WrapperCol={{
                               span: 8,
                             }}
                             labelAlign="left"
                             initialValues={{ "is_single_use" : "0"  }}
                        >   
                               <Form.Item 
                                 name={"service_id"}
                                 label={`${CONSTANTS.PLAN_NAME}`}
                                 rules={[
                                   {
                                     required: true,
                                     message: `${CONSTANTS.FIELD_REQUIRED}`,
                                   },
                                 ]}      
                               >
                                   <Select
                                       placeholder="Select a service"
                                   >  
                                     {serviceList.map(option=>{{
                                       return(
                                         <Option value={option.id}>{option.service_name}</Option>
                                       )
                                     }})}
                                     </Select>
                               </Form.Item>
                               <Form.Item 
                                 name={"coupon_name"}
                                 label={`${CONSTANTS.COUPON_NAME}`}
                                 rules={[
                                   {
                                     required: true,
                                     message: `${CONSTANTS.FIELD_REQUIRED}`,
                                   },
                                   {
                                     max: 250,
                                     message: "This field exceeds maximum number of 250 characters.",
                                   },
                                   Validators.checkOnlyAlphabets
                                 ]}      
                                 >
                                   <Input   placeholder="Coupon Name"/>
       
                               </Form.Item>
                              
                               <Form.Item 
                                 name={"percentage"}
                                 label={`${CONSTANTS.DISCOUNT_PERCENT}`}
                                 
                                 rules={[
                                   {
                                     required: true,
                                     message: `${CONSTANTS.FIELD_REQUIRED}`,
                                   },
                                   Validators.checkValidDiscount
                                 ]}      >
                                   <Input maxLength={5}   placeholder='Add discount percentage'/>
       
                               </Form.Item>
                               <Form.Item 
                                 name={"expiry_date"}
                                 label={`${CONSTANTS.DATE}`}
                                 rules={[
                                   {
                                     required: true,
                                     message: `${CONSTANTS.FIELD_REQUIRED}`,
                                   },
                                 ]}      >
                                           <RangePicker
                                           style={{width:"100%"}}
                                           disabledDate={(current)=> current && current < utils.TimezoneOffsetConversionForPatient(user_details.time_zone_offset_in_min).startOf('day')}
                                             />
                               </Form.Item>
                               <Form.Item 
                                 name={"is_single_use"}
                                 label={`${CONSTANTS.COUPON_USAGE}`}
     
                                 rules={[
                                  {
                                    required: true,
                                    message: `${CONSTANTS.FIELD_REQUIRED}`,
                                  },

                                 ]}      
                                 >
                                  <Radio.Group  
                                      options={usageOptions} 
                                      value={usageMode} 
                                      onChange={(value)=>setUsageMode(value)}/>

                               </Form.Item>    
                               <Form.Item 
                                 name={"description"}
                                 label={`${CONSTANTS.DESCRIPTION}`}
                                 rules={[
                                  {
                                    required: true,
                                    message: `${CONSTANTS.FIELD_REQUIRED}`,
                                  },
                                   {
                                     max: 250,
                                     message: "This field exceeds maximum number of 250 characters.",
                                   }
                                   ,Validators.checkValidComments
                                 ]}      
                                 >
                                   <Input.TextArea placeholder='Add Description'/>
       
                               </Form.Item>
                                   
                               
                         </Form>                
                           <div className="finish-btns submit-btn-wrapper">      
                  <Button htmlType='submit' className="action-yes"  onClick={()=>createCouponForm.current.submit()} >{CONSTANTS.SAVE}</Button>
              </div>
              </div>
             </div>
    })
  }

  useEffect( () => {
    setisinnerLoading(true)
    getData(pageNo,pageSize,selectedPlan,selectedKeys);
   
  }, []);

  const saveExpiryDate=async (data)=>{
    let params = {
       "is_single_use":usageMode=="0"?true:false,
        "coupon_id":data.coupon_id,
        "expiry_date_time": utils.FormatDate(setExpiryDate, "UTC")?.length>0?  utils.FormatDate(setExpiryDate,"DATE_12")+' '+ "23:59:59":  utils.FormatDate(data.expiry_date_time,"DATE_12")+' '+ "23:59:59"
    }
    const res = await api.updateExpiryDate(params);
    utils.Modal(false)
    if(res.data.status==200){
      message.success(res?.data.message, ErrorDuration)
    }else{
      message.error(res?.data.message, ErrorDuration)
    }
    setisinnerLoading(true)
    getData(pageNo,pageSize,filtered_plan_value,filtered_value)
  
  }
 
  const createCoupon= async(data)=>{
     data.start_date=utils.FormatDate(data.expiry_date?.[0],"DATE_12")+" "+"23:59:59"
     data.end_date= utils.FormatDate(data.expiry_date?.[1],"DATE_12")+" "+"23:59:59"
     data.is_single_use=data.is_single_use=="0"?true:false
     data.description=data.description?.trim()

     if(data?.description?.trim()?.length>0){
        delete data.expiry_date;
        const coupon_response = await api.coupon_create(data)
    if(coupon_response.data.status==200){
      message.success(coupon_response.data.message, ErrorDuration) 
      setisinnerLoading(true)
      getData(1,20,"","")
      setCreateCoupon(false)
      utils.Modal(false)
    }else{
      setCreateCoupon(false)
      utils.Modal(false)
      message.error(data.message, ErrorDuration)
      setCreateCoupon(false)
      setisinnerLoading(true)
      getData(1,20,"","")
    }
  
     }else{
      message.error("Please give valid description.", ErrorDuration)
     }
 
  }
  return (
   
      <>{ isinnerLoading?
        <Loader />
      :
      <>
      <Button className='create-coupon-btn'  onClick={(e)=>createCouponModal(true)}>{`${CONSTANTS.ADD_COUPON}`}</Button>
      <div className='coupon-table-wrapper' >
      <Table
       className='medicine-list-tabel' 
       size="small" 
       loading={isinnerLoading} 
       pagination={false}     
       scroll={{
        // x: 2400,
        y: "40vh",
      }}
       dataSource={data} 
       columns={columns}
         />
          <Pagination
          className="table-pagination"
          hideOnSinglePage={count <= 0 ? true : false}
          defaultPageSize={pageSize}
          current={pageNo || 1}
          defaultCurrent={pageNo || 1}
          total={count}
          onChange={handlePagination.bind(this)}
          pageSizeOptions={[5, 10, 20, 50, 100]}
          showSizeChanger={true}
        />
      </div>
       
         </>
}
      </>
    
  );
};

export default ManageCoupon;